export const LOCATION_SERVICE = "/location/v1";
export const LOCATION_SEARCHABLE_READ = `${LOCATION_SERVICE}/location/searchable/index.json`;
